import { useDispatchContext } from '@providers/dispatch/DispatchProvider';
import isLibraryEntity from '@utils/isLibraryEntity';
import useDesignStore from '@/components/DesignContainer/hooks/useDesignStore';
import useExtendProperties from './useExtendProperties';
import useLibraryActions from './useLibraryActions';

const useUpdateApi = () => {
  const dispatch = useDispatchContext();
  const { onLibraryUpdate } = useLibraryActions();
  const { extendProperties } = useExtendProperties();
  const level = useDesignStore((state) => state.level);

  const update = (body) => {
    const { action, entity, entityType, properties } = body;

    if (isLibraryEntity(entityType)) {
      return onLibraryUpdate({ action, entity, entityType, properties });
    }

    const extended = extendProperties(
      { action, entityType, properties },
      level
    );

    return dispatch?.onUpdate(extended);
  };

  const bulkUpdate = async (body) => {
    const { requests } = body;
    const results = [];

    try {
      for (let i = 0; i < requests.length; i++) {
        const request = requests[i];
        const result = await dispatch?.onUpdate(request);
        results.push(result);
      }
    } catch (error) {
      throw error;
    }

    return results;
  };

  return {
    update,
    bulkUpdate,
  };
};

export default useUpdateApi;
